import React from "react";
import { FiChevronRight } from "react-icons/fi";

import * as Styles from "./styles";

import { useActions } from "../../provider";

export function ChoosePaymentMethod() {
  const { stepManager, setActionsState, actionsState, config } = useActions();

  const handlePayment = (paymentMethod) => {
    setActionsState({ paymentMethod, paymentData: null });
    stepManager.next();
  };

  return (
    <Styles.PaymentMethodsContainer>
      <h1>Selecione a forma de pagamento</h1>
      <Styles.PaymentMethodsCard>
        {config.PAYMENT_METHODS.filter(payment_method => actionsState?.enabledPaymentTypes?.includes(payment_method.id)).map((payment_method) => (
          <Styles.PaymentTypeRow
            key={payment_method.type}
            onClick={() => handlePayment(payment_method.type)}
          >
            <img src={payment_method.image} />
            <div>
              <h2>{payment_method.name}</h2>
              {!!payment_method.flags && <img src={payment_method.flags} />}
            </div>
            <FiChevronRight size={64} />
          </Styles.PaymentTypeRow>
        ))}
      </Styles.PaymentMethodsCard>
    </Styles.PaymentMethodsContainer>
  );
}
